<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isReload" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReload: true,
    };
  },
  methods: {
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
  },
  created() {
    setTimeout(() => {
      var wx = this.$route.query.wx;
      if (wx) {
        window.localStorage.setItem("wx", "true");
      }
    }, 1919);

    setInterval(() => {
      let data = {
        ContentType: 10,
        PageSize: 5,
        PageIndex: 1,
      };
      this.request({
        url: "/v1.0/ThePublic/getUserContentList",
        method: "GET",
        data: data,
      }).then((res) => {
        console.log(res, 741111);
      });
    }, 1000 * 60 * 120);
  },
};
</script>
<style>
#app {
  width: 100%;
  padding: 0;
  /*   overflow: auto; */
}
</style>

